import { RESET_FORM } from '../actionTypes';
import { companyRolesActions } from '../reducer';

export default () => companyRolesActions[RESET_FORM]();
